import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {
    useCallback,
    useEffect,
    useState,
} from 'react';
import ReactPlayer from 'react-player/lazy';

import { COLORS } from '../../../constants/theme';
import { customerDataMicroserviceRequest } from '../../../services/api/customer-data';

import Loader from '../Loader';

import styles from './Videos.scss';

const Videos = ({
    entityId,
    isSponsor,
}) => {
    const [
        isLoading,
        setLoading,
    ] = useState(false);
    const [
        videos,
        setVideos,
    ] = useState([]);
    const [
        currentVideo,
        setCurrentVideo,
    ] = useState({});

    const organizationType = isSponsor ? 'sponsors' : 'organizations';
    const RESOURCE_URL = `/${organizationType}/${entityId}/videos`;

    const loadVideos = useCallback(async () => {
        setLoading(true);
        if (entityId) {
            try {
                const response = await customerDataMicroserviceRequest('get', process.env.VIDEO_MANAGEMENT_API_URL, RESOURCE_URL);

                const sortedVideos = response.data.sort((a, b) => b.id - a.id);

                setVideos(sortedVideos);
                setCurrentVideo(sortedVideos[0]);
            } catch (error) {
                setVideos([]);
                setCurrentVideo({});
            }
        }
        setLoading(false);
    }, [entityId, RESOURCE_URL]);

    useEffect(() => {
        loadVideos();
    }, [loadVideos]);

    return (
        <>
            {isLoading && <Loader color={COLORS.secondary} />}
            {currentVideo?.id && (
                <div>
                    <div className={styles.headerContainer}>
                        <div className={styles.header}>Videos</div>
                    </div>
                    {currentVideo?.id && (
                        <>
                            <div className={styles.videoLargeContainer}>
                                <ReactPlayer
                                    className={styles.reactPlayer}
                                    key={currentVideo.id}
                                    width="100%"
                                    height="100%"
                                    url={currentVideo.url}
                                    light
                                    controls
                                />
                            </div>
                            <div className={styles.videoThumbnailContainer}>
                                {videos.map((video) => {
                                    if (currentVideo && video.id === currentVideo.id) return null;
                                    return (
                                        <button
                                            type="button"
                                            key={`button-${video.id}`}
                                            onClick={() => setCurrentVideo(video)}
                                            aria-label="Select Video"
                                        >
                                            <div
                                                className={
                                                    classNames(styles.smallPlayerContainer, { [styles.activeVideo]: currentVideo && currentVideo.id === video.id })
                                                }
                                            >
                                                <ReactPlayer
                                                    className={styles.reactPlayer}
                                                    key={`thumbnail-${video.id}`}
                                                    url={video.url}
                                                    width="22rem"
                                                    height="12rem"
                                                    light
                                                    playIcon={<span />}
                                                    controls={false}
                                                />
                                            </div>
                                        </button>
                                    );
                                })}
                            </div>
                        </>
                    )}
                </div>
            )}
        </>
    );
};

Videos.propTypes = {
    entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isSponsor: PropTypes.bool,
};

Videos.defaultProps = {
    entityId: '',
    isSponsor: false,
};

export default Videos;
